// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.

// 测试环境
export const environment = {
  production: false,
  apiBaseUrl: "//192.168.21.116", // 开发环境
  // apiBaseUrl:'//192.168.195.121'  // uat
};



// WEBPACK FOOTER //
// E:/project/muyiwang/svn/project-code/trad-portal/src/environments/environment.ts